import type { ReactNode } from 'react';
import { RefreshCw, Kanban } from 'lucide-react';
import type { CrmAccessParams } from '../../../crmAccess';
import { canAccessCrmUi, resolveCrmScope } from '../../../crmAccess';

type Props = {
  access: CrmAccessParams;
  onReauth: () => void;
  children: ReactNode;
};

/** Показывает детей только при доступе к CRM; иначе — понятная заглушка (не пустой экран). */
export function CrmFunnelGate({ access, onReauth, children }: Props) {
  if (canAccessCrmUi(access)) {
    return <>{children}</>;
  }

  const scope = resolveCrmScope(access);
  return (
    <div className="p-4 space-y-4">
      <div
        className="rounded-2xl p-4 text-center"
        style={{ background: 'rgba(252,129,74,0.1)', border: '1px solid rgba(252,129,74,0.35)' }}
      >
        <Kanban size={32} color="#FC814A" className="mx-auto mb-3" />
        <p className="text-sm font-bold mb-2" style={{ color: 'var(--text-1)' }}>
          Воронка CRM недоступна
        </p>
        <p className="text-xs mb-4" style={{ color: 'var(--text-2)' }}>
          Сессия без прав CRM (scope: {scope}). Закройте Mini App, откройте снова из бота или обновите вход.
        </p>
        <button
          type="button"
          onClick={onReauth}
          className="press inline-flex items-center gap-2 px-4 py-3 rounded-xl text-xs font-bold touch-manipulation min-h-[44px]"
          style={{ background: 'rgba(99,179,237,0.2)', color: '#63B3ED', border: '1px solid rgba(99,179,237,0.35)' }}
        >
          <RefreshCw size={14} /> Обновить сессию
        </button>
      </div>
    </div>
  );
}
